import React, { useContext, useEffect, useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Backup, Mail, Visibility } from '@material-ui/icons';
import { CircularProgress, FormHelperText, Grid, IconButton, InputLabel, Tooltip } from '@material-ui/core';
import moment from 'moment';
import AssignmentReturnedIcon from '@material-ui/icons/AssignmentReturned';
import { AppStorage } from '../../../../Core/Service/storage-service';
import { SingelSelect } from '../../../../Core/FormInput';
import { getWorkflowStepsOCRDoc_List, uploadOcrDoc } from '../../../../Core/Service/workflowJobDocument-service';
import { ScreenContext } from '../WorkflowJob.Provider';
import AppContext from '../../../../App/AppContext';

const DocTableRow = ({ item, showDoc, HandelMailDocument, DownloadOcrDocument, currentVisibleDocName, isLoadingDoc, isHide }) => {
    const docAction = (item) => {
        HandelMailDocument && HandelMailDocument(item);
    };

    const downlaodOCRDocHandler = (item, isMultiVersion) => {
        DownloadOcrDocument && DownloadOcrDocument(item, isMultiVersion);
    };

    return (
        <tr className="row">
            <td>{item.ocrDocName}</td>
            {isHide && <td className="time-type">{moment(item.createdAt).format('LLL')}</td>}
            {isHide && <td className="created-by">{item.createdBy}</td>}
            <td className="actions">
                <div className="icon-button-group">
                    <Tooltip title="View">
                        <IconButton
                            color={currentVisibleDocName === item?.docName ? 'primary' : 'secondary'}
                            component="span"
                            onClick={() => showDoc(item)}
                            disabled={isLoadingDoc}
                        >
                            {isLoadingDoc && currentVisibleDocName === item?.docName ? (
                                <Grid>
                                    <Grid>
                                        <CircularProgress size={20} />
                                        &nbsp;
                                    </Grid>
                                </Grid>
                            ) : (
                                <Visibility disabled={isLoadingDoc} />
                            )}
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="Mail Document">
                        <IconButton color="secondary" component="span" onClick={() => docAction(item)}>
                            <Mail />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="Download Document">
                        <IconButton color="secondary" component="span" onClick={() => downlaodOCRDocHandler(item, false)}>
                            <AssignmentReturnedIcon />
                        </IconButton>
                    </Tooltip>
                </div>
            </td>
        </tr>
    );
};

const DocTable = ({ rec, showDoc, HandelMailDocument, DownloadOcrDocument, currentVisibleDocName, isLoadingDoc }) => {
    let hideDocCreatedValue = AppStorage.getCanHideDocumentCreation();
    return (
        <>
            {/* <table className="all-documents-header">
                <thead>
                    <tr className="header">
                        <th>Document</th>
                        <th className="time-type">Created At</th>
                        <th className="created-by">Created By</th>
                        <th className="actions">Action</th>
                    </tr>
                </thead>
            </table> */}
            <div className="body-table-container custom-scroll">
                <table className="all-documents-body">
                    <thead>
                        <tr className="header">
                            <th>Document</th>
                            {!hideDocCreatedValue && <th className="time-type">Created At</th>}
                            {!hideDocCreatedValue && <th className="created-by">Created By</th>}
                            <th className="actions">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rec.map((r, i) => (
                            <DocTableRow
                                key={i}
                                item={r}
                                showDoc={showDoc}
                                HandelMailDocument={HandelMailDocument}
                                DownloadOcrDocument={DownloadOcrDocument}
                                currentVisibleDocName={currentVisibleDocName}
                                isLoadingDoc={isLoadingDoc}
                                isHide={!hideDocCreatedValue}
                            />
                        ))}
                    </tbody>
                </table>
            </div>
        </>
    );
};

const JobAllDocs = (props) => {
    const { setDocumentWithOcrDocId, wrapperPullWorkflowDataAndSet } = useContext(ScreenContext);
    const { showToast } = useContext(AppContext);

    const [state, setState] = useState({
        allDoc: props.allDoc,
        stepsOCRDocList: []
    });
    const [uploading, setUploading] = useState(false);

    useEffect(async () => {
        let res = await getWorkflowStepsOCRDoc_List();
        setState((st) => ({ ...st, stepsOCRDocList: res.data.list || [] }));
    }, [props.jobId]);

    useEffect(() => {
        setState((st) => ({ ...st, allDoc: props.allDoc }));
    }, [props.allDoc]);

    const handleClose = () => {
        props.onClose && props.onClose();
    };

    const showDoc = (item) => {
        props.showDoc && props.showDoc(item.ocrDocId, item.docName, item.IsVideo);
    };

    const singleSelectChange = (nm) => (ev, vl) => {
        setState((st) => {
            let newSt = {
                ...st,
                [nm]: vl
            };
            return newSt;
        });
    };

    const uploadDoc = async (e) => {
        // const firstFile = e.target.files[0];
        // if (firstFile) {
        const formData = new FormData();
        for (let i = 0; i < e.target.files.length; i++) {
            formData.append(e.target.files[i].name, e.target.files[i]);
        }
        // formData.append(firstFile.name, firstFile);
        setUploading(true);
        let res = await uploadOcrDoc(props.jobId, state.selectStepDoc.id, formData);
        // setDocumentWithOcrDocId(state.selectStepDoc.id, res.data.docName);
        wrapperPullWorkflowDataAndSet();
        setUploading(false);
        if (res.success) {
            showToast('File Uploaded successfully.');
            // showDoc('VIEW');
        }
        // }
    };

    return (
        <>
            <Dialog open={true} onClose={handleClose} maxWidth="md" className="dialog-custom all-documents-modal">
                <DialogTitle style={{ padding: '10px 10px 0px 10px' }}>
                    Job Documents
                    <div className="title-header-actions">
                        <span className="close-icon" onClick={handleClose}>
                            &times;
                        </span>
                    </div>
                </DialogTitle>
                <DialogContent>
                    <Grid container>
                        <Grid item xs={12}>
                            <Grid container spacing={1} alignItems="center">
                                <Grid item xs>
                                    {/* <InputLabel required shrink>
                                        Editable in Workflow
                                    </InputLabel> */}
                                    <SingelSelect
                                        options={state.stepsOCRDocList || []}
                                        value={state.selectStepDoc}
                                        onChange={singleSelectChange('selectStepDoc')}
                                    />
                                    <FormHelperText error>{state.selectStepDocError}</FormHelperText>
                                </Grid>
                                <Grid item>
                                    <Tooltip title="Upload Document">
                                        <label>
                                            <IconButton color="secondary" component="span" disabled={!state.selectStepDoc}>
                                                <Backup />
                                                <input
                                                    disabled={!state.selectStepDoc}
                                                    type="file"
                                                    onChange={uploadDoc}
                                                    // className="upload-btn-input-file"
                                                    style={{ display: 'none' }}
                                                    accept="video/mp4,video/x-m4v,video/*,image/*,application/pdf"
                                                    // accept="image/*,application/pdf"
                                                    multiple
                                                />
                                                {uploading && <CircularProgress size={40} className="upload-progress" color="secondary" />}
                                            </IconButton>
                                        </label>
                                    </Tooltip>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            <div className="all-documents">
                                <DocTable
                                    rec={state.allDoc}
                                    showDoc={showDoc}
                                    HandelMailDocument={props.HandelMailDocument}
                                    DownloadOcrDocument={props.DownloadOcrDocument}
                                    currentVisibleDocName={props.currentVisibleDocName}
                                    isLoadingDoc={props.isLoadingDoc}
                                />
                            </div>
                        </Grid>
                    </Grid>
                </DialogContent>
            </Dialog>
        </>
    );
};

export default JobAllDocs;
